// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__j2HRc","button":"styles_button__Mu-G3","submit":"styles_submit__uJGov","print":"styles_print__gJzrq","disabled":"styles_disabled__ZMwx6"};